import React from 'react';

export default function SectionHeader({ title, icon, rightSectionFunction }) {
  return (
    <div className="section-header">
      <div className="row">
        <div className="col-sm-9">
          <h1 className="title">
            <i className={icon}> </i>
            <span> {title}</span>
          </h1>
        </div>
        <div className="col-sm-3">{!!rightSectionFunction && rightSectionFunction()}</div>
      </div>
    </div>
  );
}